import React from 'react';

const Services = () => {
  return (
    <section id="services" class="services section">

      <div class="container section-title" data-aos="fade-up">
        <h2>Services</h2>
        <p>Think beyond routine. Our AI and automation services help you build smarter processes, powerful platforms, and intelligent customer experiences that drive real impact.</p>
      </div>

      <div class="container" data-aos="fade-up" data-aos-delay="100">

        <div class="row gy-4">
          <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div class="service-card">
              <div class="service-icon">
                <i class="bi bi-palette"></i>
              </div>
              <h4><a href="#">AI Agents</a></h4>
              <p>The Agentic shift is here. Automation is no longer enough — intelligence is the new engine.
                Our AI agents understand intent, make decisions, and execute with precision.
                From internal systems to customer journeys, they keep your business moving while you focus on innovation.</p>
              <div class="service-badge">Most Popular</div>
              {/* <a href="#" class="service-link">
                <span>Learn More</span>
                <i class="bi bi-arrow-right"></i>
              </a> */}
            </div>
          </div>

          <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
            <div class="service-card">
              <div class="service-icon">
                <i class="bi bi-layout-text-window-reverse"></i>
              </div>
              <h4><a href="#">Workflow Automations</a></h4>
              <p>No inputs required. These automations work autonomously — analyzing data, sending invoices, onboarding clients, and generating reports. Everything that used to wait for you now happens before you even ask.</p>
              {/* <a href="#" class="service-link">
                <span>Learn More</span>
                <i class="bi bi-arrow-right"></i>
              </a> */}
            </div>
          </div>

          <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="400">
            <div class="service-card">
              <div class="service-icon">
                <i class="bi bi-code-slash"></i>
              </div>
              <h4><a href="#">AI Voice Agents</a></h4>
              <p>Inbound or outbound—AI voice agents talk to your leads and customers in real-time. They answer, qualify, remind, and follow up—so you don’t have to. 2025’s standard for modern business communication.</p>
              {/* <a href="#" class="service-link">
                <span>Learn More</span>
                <i class="bi bi-arrow-right"></i>
              </a> */}
            </div>
          </div>

          <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="500">
            <div class="service-card">
              <div class="service-icon">
                <i class="bi bi-phone"></i>
              </div>
              <h4><a href="#">Predictive Intelligence</a></h4>
              <p>We turn data into foresight. Our predictive intelligence systems analyze trends, forecast results, and uncover insights that help businesses act smarter and faster.</p>
              {/* <a href="#" class="service-link">
                <span>Learn More</span>
                <i class="bi bi-arrow-right"></i>
              </a> */}
            </div>
          </div>

          <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
            <div class="service-card">
              <div class="service-icon">
                <i class="bi bi-megaphone"></i>
              </div>
              <h4><a href="#">Web Development</a></h4>
              <p>We craft stunning, high-performance websites that combine design, usability, and speed. Every site we build is optimized to engage users, elevate brands, and drive measurable growth.</p>
              {/* <a href="#" class="service-link">
                <span>Learn More</span>
                <i class="bi bi-arrow-right"></i>
              </a> */}
            </div>
          </div>

          <div class="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
            <div class="service-card">
              <div class="service-icon">
                <i class="bi bi-search"></i>
              </div>
              <h4><a href="#">Digital Marketing</a></h4>
              <p>We create digital marketing strategies that connect brands with people. From SEO and performance marketing to social campaigns and automation, we help businesses grow smarter in the digital age.</p>
              {/* <a href="#" class="service-link">
                <span>Learn More</span>
                <i class="bi bi-arrow-right"></i>
              </a> */}
            </div>
          </div>

        </div>

        <div class="row mt-5" id="ScheduleCall">
          <div class="col-12 text-center" data-aos="fade-up" data-aos-delay="400">
            <div class="services-cta">
              <h3>Ready to Transform Your Business with AI and Digital Innovation?</h3>
              <p>Let's discuss your project and create something amazing together</p>
              <a href="https://calendly.com/omkarbhatwadekar/30min" target='_blank' class="btn btn-primary">Schedule a Free Strategy Call</a>
            </div>
          </div>
        </div>

      </div>

    </section>

  );
};

export default Services;
